import React, {
	useReducer,
	createContext,
	useMemo,
	useContext,
	useCallback,
	useEffect,
} from 'react'
import * as views from './drawers/index'
import styles from 'assets/styles/theme.module.sass'

import { reducer } from './reducer'
import toMS from '@jimmyboys/liita-ui/dist/utils/toMS'
import { useLocation, useParams } from 'react-router-dom'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const { transitionTime } = styles

export const DrawerManagerContext = createContext(undefined)

const initialState = {
	type: null,
	data: null,
}

export const useDrawerContext = () => useContext(DrawerManagerContext)

export const DrawerProvider = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState)
	const location = useLocation()
	const history = useHistory()
	const { clinicalProcessId } = useParams()
	const [searchParams, , setSearchParams] = useQueryParams(location)

	const { type, data, ...others } = state

	const values = useMemo(
		() => ({
			dispatch,
		}),
		[]
	)

	const drawerFunctions = {
		openDrawer(type, data, location) {
			location && history.push(location)

			const drawerOpenTransitionTime = location
				? toMS(transitionTime) * 2
				: 0

			setTimeout(() => {
				dispatch({
					action: 'OPEN_DRAWER',
					payload: {
						type,
						data,
					},
				})
			}, drawerOpenTransitionTime)
		},
	}

	const View = views[type]

	const handleClose = useCallback(() => {
		setTimeout(() => {
			if (type === 'CommentThreadDrawer') {
				setSearchParams({ comment: '' })
			}
			dispatch({ action: 'CLEAR_DRAWER' })
		}, toMS(transitionTime))
	}, [type, setSearchParams])

	useEffect(() => {
		if (type === null && searchParams?.comment && clinicalProcessId) {
			dispatch({
				action: 'OPEN_DRAWER',
				payload: {
					data: {
						processId: clinicalProcessId,
						id: searchParams.comment,
					},
					type: 'CommentThreadDrawer',
				},
			})
		}
	}, [clinicalProcessId, searchParams?.comment, type])

	return (
		<DrawerManagerContext.Provider
			value={{ ...values, ...drawerFunctions }}
		>
			{data !== null && (
				<View handleClose={handleClose} data={data} {...others} />
			)}
			{children}
		</DrawerManagerContext.Provider>
	)
}
